import Image1 from "../../assets/Certficates/Saswat Seth_SQL-internship_Cental_University_of_Odisha,Koraput_C.V. Raman Global University_page-0001.jpg";
import Image2 from "../../assets/Certficates/Saswat_Seth_Google_Data_Analytics_page-0001.jpg";
import Image3 from "../../assets/Certficates/GoogleAIEssentials_Badge_page-0001 (3).jpg";
import Image4 from "../../assets/Certficates/UC-9c3d7b43-2498-42a2-9156-98c133083bbe.jpg";
import Image5 from "../../assets/Certficates/Saswat_Seth_Analyze_Data_To_Answer_Questions_page-0001 (1).jpg";
import Image6 from "../../assets/Certficates/Saswat_Seth_Data_Analysis_with_R_Programming_page-0001.jpg";
import Image7 from "../../assets/Certficates/Saswat_Seth_Share_Data_Through_the_Art_of_Visulization_page-0001.jpg";
import Image8 from "../../assets/Certficates/The Power of Statistics_page-0001.jpg";
import Image9 from "../../assets/Certficates/Saswat_Seth_Regression_Analysis_Simplify_Complex_Data_page-0001.jpg";
import Image10 from "../../assets/Certficates/Saswat_Seth_Google_Advanced _Data_Analytics_page-0001.jpg";
import Image11 from "../../assets/Certficates/Saswat_Seth_Process_Data_from_Dirty_to_Clean_page-0001.jpg";
import Image12 from "../../assets/Certficates/The Nuts and Bolts of Machine Learning_page-0001.jpg";

export const Data = [
  {
    id: 1,
    image: Image10, //CertificateImage, // Use the certificate image here
    link: "https://www.coursera.org/account/accomplishments/professional-cert/5N22BT9U64BZ",
  },
  {
    id: 2,
    image: Image1,
    link: "https://drive.google.com/file/d/1K2oxqvwMkGDbcQRA1R9HokazmShXR_er/view?usp=sharing",
  },
  {
    id: 3,
    image: Image3,
    link: "https://www.coursera.org/account/accomplishments/verify/YTCLYJWKHPFJ",
  },
  {
    id: 4,
    image: Image2,
    link: "https://www.coursera.org/account/accomplishments/specialization/S3IVT2RQ3UTT",
  },
  {
    id: 5,
    image: Image4,
    link: "https://www.udemy.com/certificate/UC-9c3d7b43-2498-42a2-9156-98c133083bbe/",
  },
  {
    id: 6,
    image: Image11,
    link: "https://www.coursera.org/account/accomplishments/verify/4BZKCKLRQZGT",
  },
  {
    id: 7,
    image: Image5,
    link: "https://www.coursera.org/account/accomplishments/verify/Y32X34QRQL5Y",
  },
  {
    id: 8,
    image: Image6,
    link: "https://www.coursera.org/account/accomplishments/verify/P8FGD547WS5S",
  },
  {
    id: 9,
    image: Image7,
    link: "https://www.coursera.org/account/accomplishments/verify/V7NUX95W6MX8",
  },

  {
    id: 10,
    image: Image8,
    link: "https://www.coursera.org/account/accomplishments/verify/1U5V5OWRZ99S",
  },
  {
    id: 11,
    image: Image9,
    link: "https://www.coursera.org/account/accomplishments/verify/X4CZ3XBH7M4W",
  },
  {
    id: 12,
    image: Image12,
    link: "https://www.coursera.org/account/accomplishments/verify/6IEBKQ43DBFY",
  },
  // Add more testimonials as needed
];
